export const createBlockSticker = (messagge) => {
  const htmlMessagge = `
    <div class="editor-loader-block-sticker bg-color-existing-canvas">
      <div class="option-button-container-relative">
          <div class="editor-loader-block-sticker-text text-center h5">${messagge}</div>
      </div>
    </div>`;

  return htmlMessagge;
};
